import * as React from 'react';
import classNames from 'classnames';
import './cn-badge.scss';
export const CnBadge = (props) => {
    const { className, count, overflowCount, children, content = '', shape, ...others } = props;
    const prefix = 'cn-ui-m-';
    const auto = React.Children.count(children) > 0;
    let sup = count;
    sup = Number(count);
    if (!isNaN(sup) && sup !== 0) {
        sup = sup > (overflowCount || 99) ? `${overflowCount}+` : sup;
    }
    else {
        // string
        sup = count;
    }
    const badgeChildrenRender = () => {
        if (content) {
            return (React.createElement("div", { className: classNames({
                    [`${prefix}badge--custom`]: !!content,
                    [`${prefix}badge-content--auto`]: auto,
                }) }, content));
        }
        if (shape === 'dot') {
            return (React.createElement("div", { className: classNames({
                    [`${prefix}badge-content`]: true,
                    [`${prefix}badge-content--dot`]: true,
                    [`${prefix}badge-content--auto`]: auto,
                }) }));
        }
        if (shape === 'normal') {
            return (React.createElement("div", { className: classNames({
                    [`${prefix}badge-content`]: true,
                    [`${prefix}badge-content--normal`]: true,
                    [`${prefix}badge-content--auto`]: auto,
                }) },
                React.createElement("span", { className: `${prefix}badge-text` }, sup)));
        }
        return (React.createElement("div", { className: classNames({
                [`${prefix}badge-content`]: true,
                [`${prefix}badge-content--normal`]: true,
                [`${prefix}badge-content--${shape}`]: !content,
            }) },
            React.createElement("span", { className: `${prefix}badge-text` }, sup)));
    };
    return (React.createElement("div", { ...others, className: classNames(className, `${prefix}badge`, `${prefix}badge--${shape}`, {
            [`${prefix}badge--auto`]: auto,
        }) },
        children,
        badgeChildrenRender()));
};
CnBadge.defaultProps = {
    shape: 'normal',
    count: 0,
    overflowCount: 99,
};
CnBadge.displayName = 'CnBadge';
